import { createContext, useContext } from 'react';

export const SearchBarPanelContext = createContext();

export const useSearchBarPanelContext = () => useContext(SearchBarPanelContext);
